module.exports = __webpack_public_path__ + "img/QA.23001fba.svg";